import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { SectionTitle } from '@/features/Application/elements'
import { createModal } from '@/components/modalize/mui'
import { MobileIdentityVerification } from '@/features/Application/identity-verification'
import { MobileSocialVerification } from '@/features/Application/social-verification'
import { MobileEmploymentVerification } from '@/features/Application/employment-verification'
import { MobileIncomeVerification } from '@/features/Application/income-verification'
const Wrapper = styled.div`
  margin: 25px 8px;
`
const MobileMenuModal = ({ data, application, isLocked, isLoading, standalone = false }) => {
  const { t } = useTranslation()
  const title = t('l.application.view.trustworthiness.label', 'Trustworthiness')

  return (
    <Wrapper>
      <SectionTitle
        title={title}
        score={data?.score}
        maxScore={data?.max_score}
        rate={data?.rate}
        isLocked={isLocked}
        isLoading={isLoading}
      />
      <MobileIdentityVerification data={data?.identity} isLocked={isLocked} isLoading={isLoading} />
      <MobileSocialVerification data={data?.social} isLocked={isLocked} isLoading={isLoading} />
      <MobileEmploymentVerification
        data={data?.employment}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
      <MobileIncomeVerification
        data={data?.income}
        application={application}
        isLocked={isLocked}
        isLoading={isLoading}
        standalone={standalone}
      />
    </Wrapper>
  )
}

export const show = createModal(MobileMenuModal, {
  width: 'auto',
  customIsMobileBreakpoint: '900px',
  sheet: true,
  hasHeader: false
})
